"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tenantIdEquals = exports.tenantIdOfOrganisation = exports.organisationsPerDisease = exports.assertIsValidTenantIdentifier = exports.getTenantSettings = exports.organisationMap = exports.organisations = exports.diseaseMap = exports.diseases = void 0;
var diseases_1 = require("./diseases");
Object.defineProperty(exports, "diseases", { enumerable: true, get: function () { return diseases_1.diseases; } });
const assert_1 = __importDefault(require("assert"));
const diseases_2 = require("./diseases");
const diseases_3 = require("../model/diseases");
exports.diseaseMap = Object.fromEntries(diseases_2.diseases.map((config) => [config.disease, config]));
exports.organisations = diseases_2.diseases.flatMap((disease) => disease.organisations);
exports.organisationMap = Object.fromEntries(exports.organisations.map((settings) => [settings.organisation, settings]));
const getTenantSettings = ({ disease, organisation, }) => organisation ? exports.organisationMap[organisation] : exports.diseaseMap[disease];
exports.getTenantSettings = getTenantSettings;
const assertIsValidTenantIdentifier = ({ disease, organisation, } = {}) => {
    var _a;
    (0, assert_1.default)(disease && disease in diseases_3.Disease, `Unknown disease: ${disease}`);
    (0, assert_1.default)(!organisation ||
        ((_a = exports.organisationsPerDisease
            .get(disease)) === null || _a === void 0 ? void 0 : _a.has(organisation)), `Unknown organisation: ${organisation} for disease ${disease}`);
    return { disease, organisation };
};
exports.assertIsValidTenantIdentifier = assertIsValidTenantIdentifier;
exports.organisationsPerDisease = new Map(diseases_2.diseases.map((disease) => [
    disease.disease,
    new Set(disease.organisations.map(({ organisation }) => organisation)),
]));
const tenantIdOfOrganisation = (organisation) => ({
    disease: diseaseOfOrganisation[organisation],
    organisation,
});
exports.tenantIdOfOrganisation = tenantIdOfOrganisation;
const diseaseOfOrganisation = Object.fromEntries(diseases_2.diseases.flatMap((disease) => disease.organisations.map(({ organisation }) => [
    organisation,
    disease.disease,
])));
const tenantIdEquals = (tenantId1, tenantId2) => {
    return ((tenantId1 === null || tenantId1 === void 0 ? void 0 : tenantId1.disease) === (tenantId2 === null || tenantId2 === void 0 ? void 0 : tenantId2.disease) &&
        (tenantId1 === null || tenantId1 === void 0 ? void 0 : tenantId1.organisation) === (tenantId2 === null || tenantId2 === void 0 ? void 0 : tenantId2.organisation));
};
exports.tenantIdEquals = tenantIdEquals;
